import { useContext, useEffect } from 'react'
import { AuthContext } from '@/context/auth-context'
import { getOutlookWorkspace } from '@/outlook-addin/fetch/workspace'
import { useAppDispatch } from '@/store/store-hooks'
import { MattersActions } from '@/matter/store/slice'
import { MatterType, MatterViewerRole } from '@/matter/store/schemas'

/** Discovers an existing private workspace without creating one or listing it as a shared matter. */
export function usePersonalOutlookWorkspace() {
  const user = useContext(AuthContext)?.user
  const userId = user?.uid
  const isAnonymous = user?.isAnonymous
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(MattersActions.setPersonalWorkspace(null))
    if (!userId || isAnonymous) return
    let cancelled = false
    void getOutlookWorkspace().then(
      (workspace) => {
        if (cancelled) return
        dispatch(
          MattersActions.setPersonalWorkspace(
            workspace?.type === MatterType.OUTLOOK_WORKSPACE && workspace.viewer_role === MatterViewerRole.Owner && workspace.user_id === userId
              ? workspace
              : null
          )
        )
      },
      () => {
        // Discovery is optional; a direct handoff reauthorizes with a separate matter-detail read.
      }
    )
    return () => {
      cancelled = true
    }
  }, [dispatch, userId, isAnonymous])
}
